/* eslint-disable import/order */
/* eslint-disable import/first */
// import './src/why-did-you-render'; // uncomment to diagnose re-render issues

// Redirect dotlottie WASM loading to our own origin (avoids using jsdelivr/unpkg CDN).
// On native this resolves to a no-op stub. See src/utils/lottie/init-wasm.web.ts
import './src/utils/lottie/init-wasm';

// anything that must run first before everything else
import { TraceName, startTrace } from './src/utils/performance/trace';

startTrace(TraceName.JAVASCRIPT_START_TO_SIMPLE_HOME_PAGE_LOADED); // javascript_start -> simple homepage loaded time

import 'react-native-reanimated';
import 'react-native-get-random-values';
import { updateId } from 'expo-updates';
import { enableScreens } from 'react-native-screens';
import { initLaunchDarklyPromise } from './src/state/launchdarkly/launchdarkly-core';
import { appVersion, binaryRuntimeAppVersionWithBuildNumber } from './src/utils/app-version-info';
import { SyncStorageKey, syncStorage } from './src/utils/environment/sync-storage';
import {
  getCrashlytics,
  recordError,
  setAttribute,
  setUserId,
} from './src/features/observability/crashlytics';
import { initDatadog } from './src/features/observability/datadog';
import { getDeviceIdAsync } from './src/utils/device-id';
import { appStartId } from './src/utils/environment';
import { setupGlobalErrorHandler } from './src/utils/fatal-error-handler';

const crashReporter = getCrashlytics();

const setCrashReporterAttributes = () => {
  setAttribute(crashReporter, 'binaryRuntimeVersion', binaryRuntimeAppVersionWithBuildNumber);
  setAttribute(crashReporter, 'appVersion', appVersion);
  setAttribute(crashReporter, 'updateId', updateId ?? 'UNKNOWN');
  setAttribute(crashReporter, 'appStartId', appStartId);
};

// SETUP datadog logging
try {
  try {
    initDatadog();
  } catch (error) {
    setCrashReporterAttributes(); // so we have a place to log datadog init failure
    recordError(
      crashReporter,
      new Error(`Failed to init datadog logging! ${error?.toString()}`)
    );
  }
} catch (error) {}

// make sure the ld import doesn't get tree shaken and runs
void initLaunchDarklyPromise;

// SETUP Datadog crash/error reporting context
try {
  setCrashReporterAttributes();
  getDeviceIdAsync().then(deviceId => setAttribute(crashReporter, 'deviceId', deviceId));
  // @ts-ignore
  setUserId(crashReporter, syncStorage.getString(SyncStorageKey.USER_ID));
} catch (_error) {
  // ignore - never has fired and where would we log?
}

// SETUP global error handler
setupGlobalErrorHandler();

enableScreens(true);

// normal app start invokes src/app/_layout.tsx
// eslint-disable-next-line import/first
import 'expo-router/entry';
